import { reviewService } from "../services/reviews/index1";

const name = "reviews";

const initialState = {
  list: [],
  loading: {
    fetch: false,
    loadMore: false,
  },
  total: 0,
};

export const fetchList = (params) => ({
  type: `${name}/fetchList`,
  payload: params,
});

export const fetchMore = (params) => ({
  type: `${name}/fetchMore`,
  payload: params,
});

export default {
  namespace: name,
  state: initialState,
  effects: {
    *fetchMore({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "loadMore" });
      try {
        const response = yield call(reviewService.fetchList, payload);

        yield put({
          type: "updateList",
          payload: {
            list: response.data.list,
            total: response.data.total,
          },
        });
      } catch (error) {
        console.error("Error fetching more reviews:", error);
      }
      yield put({ type: "stopLoading", loadingType: "loadMore" });
    },
    *fetchList({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "fetch" });
      try {
        const response = yield call(reviewService.fetchList, payload);

        yield put({
          type: "setList",
          payload: {
            list: response.data.list,
            total: response.data.total,
          },
        });
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
      yield put({ type: "stopLoading", loadingType: "fetch" });
    },
  },
  reducers: {
    updateList(state, { payload }) {
      return {
        ...state,
        list: [...state.list, ...payload.list],
        total: payload.total,
      };
    },
    setList(state, { payload }) {
      return {
        ...state,
        list: payload.list,
        total: payload.total,
      };
    },
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
  },
};
